import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import { GADataProps } from "@components/GAData/GAData";
import EventsAwardsHeader from "@events-awards/components/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/components/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import LandingPageArticle from "@events-awards/components/LandingPageArticle";
import {
  AwardType,
  EventsAwardsLandingPageData,
} from "@events-awards/utils/types";
import { useInjectClientData } from "@hooks/useInjectClientData";
import SBANominationsDescription from "@sba/components/HomePageNominationsDescription";
import JudgingPanel from "@sba/components/JudgingPanel";
import OrganiserDetails from "@sba/components/OrganiserDetails";
import SBADescription from "@sba/components/SBADescription";
import SBAFooter from "@sba/components/SBAFooterComponents/SBAFooter";

/**
 * Component to render event and awards page
 */
const EventsAwardsSBAPageContent = ({
  articleProps,
  gaProps,
}: EventsAwardsLandingPageData & {
  gaProps: GADataProps;
}): React.ReactElement => {
  useInjectClientData({ gaProps });

  return (
    <div
      className="w-full"
      data-testid="events-awards-sba-page-content-component"
    >
      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.SBA} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <LandingPageArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <SBADescription />

      <div className="mt-1 bg-gray-150 px-3 py-8 md:px-6 lg:px-0">
        <Container>
          <SBANominationsDescription />
        </Container>
      </div>

      <OrganiserDetails />

      <JudgingPanel />

      <SBAFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsSBAPageContent;
